export default __webpack_public_path__ + "static/media/demo.326f642b.mov";